import { connect } from 'react-redux';
import Individual from '../../../../views/Finance/Spp/CreateInvoice/Individual.createinvoice.view';
import { getAdjustmentJournal } from '../../../../states/thunks/finance.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAdjustmentJournal: payload => dispatch(getAdjustmentJournal(payload)),
  };
}

export default connect(null, mapDispatchToProps)(Individual);